import {useState } from 'react';
import { XMarkIcon, ChartBarIcon, Bars3BottomLeftIcon, ViewfinderCircleIcon,
  ChartBarSquareIcon, MapIcon, PlusIcon, MagnifyingGlassIcon,
   ArrowTrendingUpIcon, ChartPieIcon, DocumentDuplicateIcon, NoSymbolIcon, AdjustmentsHorizontalIcon  } from '@heroicons/react/24/outline';
import { TreeGlyph, ScatterGlyph, LogGlyph, CogGlyph  } from './Buttons.jsx';


export function ProjectCard({mode}) {
  const [isProject, setIsProject] = useState(mode=='long');
  return (
    
    <div className={`${mode === 'long' ? 'long-panel' : 'wide-panel'}`}>

      <div className="flex flex-col w-full gap-4 px-8 py-4 justify-start">
        <div className="flex flex-row gap-4 items-center">
          <button 
            className={`text-lg px-4 py-2 rounded-lg self-start min-w-[100px] ${isProject ? 'underline font-bold' : ''}`} 
            onClick={() => setIsProject(true)}
          >
            Project
          </button>
          <button 
            className={`text-lg  px-4 py-2 rounded-lg self-start min-w-[100px] ${!isProject ? 'underline font-bold' : ''}`}  
            onClick={() => setIsProject(false)}
          >
            Tool
          </button>
        </div>
        
        {isProject ? (
          <>
          <h1 className="text-2xl font-bold">Explore the virus world with Virome@tlas-explorer</h1>
          <h2 className="text-lg font-bold text-gray-500">About the {isProject ? 'Virome@tlas Project' : 'Virome@tlas-explorer Tool'}</h2>
          <p>Viral diseases represent a global and systemic health challenge. Recent pandemics have highlighted the close connections between human, animal, and environmental health, in a context marked by the accelerated degradation of ecosystems and the interdependence of a globalized economy.</p>
          <p>A comprehensive approach to viruses is essential to better understand the key interactions that sustain a unified concept of health (One Health). This approach aims to improve prevention and societal adaptation to health crises by incorporating a deep understanding of viral diversity and their ability to adapt to various hosts—human and non-human—across diverse environments.</p>
          <p>The Virome@tlas project aspires to develop a cloud-based digital platform for global virus surveillance. This platform will analyze interactions between viruses, their hosts, and their environments to better understand their geographic distribution and the mechanisms behind epidemic emergence.</p>
          <p>By integrating massive sequencing data from living organisms—available in public archives—with large-scale geographic data, this innovative tool will help identify priority geographic areas, animals, and viruses to monitor, thereby strengthening global preparedness for future pandemics.</p>
          <p className="text-gray-600 mt-10">This work is supported by a grant from the French National Research Agency as part of the “Investissements d’Avenir ExcellencES” program from France 2030 (SHAPE-Med@Lyon ; ANR- 22-EXES-0012)</p>
          <p className="text-blue-500"><a href="https://viromeatlas.univ-lyon1.fr/" target="_blank" rel="noopener noreferrer">Learn more</a></p>
          <p className="mt-5 text-white">...</p>
          </>
        ) : (
  <div className="flex flex-col gap-8 text-[11px] leading-relaxed pb-10">
    {/* --- INTRODUCTION --- */}
    <section>
      <h3 className="text-2xl font-bold text-gray-800 mb-2 border-b-2 border-gray-100 pb-1 uppercase tracking-wider">The Virome@tlas-explorer tool</h3>
    </section>
    <section>
      <h3 className="text-sm font-bold text-gray-800 mb-2 border-b-2 border-gray-100 pb-1">Global Controls</h3>
      <div className="space-y-3">
        <div className="flex items-start gap-3 border-b-2 border-gray-100">
              <div 
        className="mx-2 min-w-[20px] min-h-[20px] max-w-[20px] max-h-[20px] bg-white border-[1.5px] border-gray-800 rounded-full shadow-lg w-8 h-8 items-center justify-center flex shrink-0"
      >
        {'?'}
      </div>/
      <div 
        className="mx-2 min-w-[20px] min-h-[20px] max-w-[20px] max-h-[20px] bg-white border-[1.5px] border-gray-800 rounded-full shadow-lg w-8 h-8 items-center justify-center flex shrink-0"
      >
        {'X'}
      </div>
                <div className="mb-2">
            <strong>Show/hide info:</strong> Show/hide this panel with the project description and tool manual.
          </div>
          </div>
                <div className="flex items-start gap-3 border-b-2 border-gray-100">
              <div 
        className="px-2 py-1 bg-white border-[1.5px] border-gray-800 rounded-lg shadow-lg w-18 h-8 items-center justify-center flex shrink-0"
      >
        {'Expert'}
      </div>
      <div className="mb-2">
            <strong>Switch mode:</strong> Switch between basic and expert mode.
      </div>
          </div>
          <div className="flex items-start gap-3 border-b-2 border-gray-100">
              <div 
        className="h-12 w-20 px-1 rounded-full font-bold border-2 flex items-center justify-center bg-gray-100 border-gray-400 text-gray-800 shadow-sm"
      >
        {'+ G'}
      </div><span className="py-2">/</span><div 
        className="h-10 w-24 px-1 rounded-lg font-bold border-2 flex items-center justify-center bg-gray-100 border-gray-400 text-gray-800 shadow-sm"
      >
        {'+ Geom'}
      </div>
      <div className="mb-2">
            <strong>Enrich with extra geographical data:</strong> Select additional geographic values (columns) to enrich the table(s) based on the `geom_id` lookup key.
            </div>
          </div>
          <div className="flex items-start gap-3 border-b-2 border-gray-100">
              <div 
        className="h-12 w-20 px-1 rounded-full font-bold border-2 flex items-center justify-center bg-gray-100 border-gray-400 text-gray-800 shadow-sm"
      >
        {'STAT'}
      </div>
      <div className="mb-2">
            <strong>Search via STAT:</strong> Select one or more viruses or viral families to search all the samples in which these have been identified (with a number of reads equal or greater than the set threshold(s)) by the <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC8450716/" className='text-blue-800'>STAT</a> tool.
            </div>
          </div>
          
      </div>
    </section>
      <section>
      <h3 className="text-sm font-bold text-gray-800 mb-2 border-b-2 border-gray-100 pb-1 uppercase tracking-wider">Basic Mode</h3>
      <p>
        Use the search bar to explore the samples associated with a specific host, virus, or environment, location or disease. Hosts and viruses can also be searched by their order, class, phylum etc. The results of the query are visualized as points on the map via their coordinates, with a taxonomic representation onto the tree of life via the NCBI's taxIds of all the associated hosts, and as a raw table.
      </p>
      <div className="flex items-start gap-3 border-b-2 mt-4 border-gray-100">
      <div 
        className="h-12 w-24 px-1 rounded-full font-bold border-2 flex items-center justify-center bg-gray-100 border-gray-400 text-gray-800 shadow-sm"
      >
        <AdjustmentsHorizontalIcon className="w-8 h-8 text-gray-800" />
      </div>
      <div className="mb-2">
            <strong>Show/hide side panels:</strong> Allows for an "hybrid" mode between basic and expert, with the same panels as in expert mode but keeping the main basic mode layout, use the panels for filtering or visualization.
            </div>
          </div>
    </section>
    <section>
      <h3 className="text-sm font-bold text-gray-800 mb-2 border-b-2 border-gray-100 pb-1 uppercase tracking-wider">Expert Mode</h3>
      <p>

      </p>
    </section>

    {/* Global Controls */}
    <section>
      <h3 className="text-sm font-bold text-gray-800 mb-2 border-b-2 border-gray-100 pb-1">Data Retrieval Controls</h3>
      <div className="space-y-3">
        <div className="flex items-start justify-start gap-3 border-b-2 border-gray-100">
          <div className="bg-gray-100 border-2 border-gray-300 p-1.5 rounded-lg w-24 h-8 text-xs">
            viromeatlas/..
          </div>
          <div className="mb-2">
            <strong>Search bar:</strong> Paste a path to a specific table in the Virome@tlas S3 datalake or to any publicly hosted parquet file. 
          </div>
        </div>
                <div className="flex items-start gap-3 border-b-2 border-gray-100">
          <div className="bg-gray-100 border-2 border-gray-300 p-1.5 rounded-lg w-16 h-8 text-xs">
            100000
          </div>
          <div className="mb-2">
            <strong>Samples:</strong> Select the maximum number of samples to query, the same limit is applied to queries in basic mode.
          </div>
        </div>
                <div className="flex items-start gap-3 border-b-2 border-gray-100">
          <div className="bg-gray-100 border-2 border-gray-300 p-1.5 rounded-lg shrink-0">
            <PlusIcon className="w-4 h-4 text-gray-600" />
          </div>
          <div className="mb-2">
            <strong>Add Constraint:</strong> Adds a new SQL-style filter (e.g., <code>host='Homo sapiens'</code>) to the data query before loading, double click on a constraint to modify it, remove it clicking on its X.
          </div>
        </div>
      
        {/*
        <div className="flex items-start gap-3">
          <div className="bg-gray-200 px-2 py-1 rounded-lg text-[10px] font-bold shrink-0 border border-gray-300">
            Upload Table
          </div>
          <div>
            <strong>File Upload:</strong> Load a local <code>.csv</code> or <code>.tsv</code> file directly into the explorer.
          </div>
        </div>
        */}
      </div>
    </section>

    {/* Panel Header Buttons */}
    <section>
      <h3 className="text-sm font-bold text-gray-800 mb-2 border-b-2 border-gray-100 pb-1">Common Panel Controls</h3>
      <p className="mb-3 text-gray-500">Found in the top-right header of each panel</p>
      
      <div className="grid grid-cols-1 gap-3 border-b-2 border-gray-100">
        

        {/* Remove */}
        <div className="flex items-center gap-3">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <XMarkIcon className="w-4 h-4 text-red-700" />
          </span>
          <div className="mb-2"><strong>Remove:</strong> Closes the panel and clears its specific filters.</div>
        </div>
        {/* Duplicate */}
        <div className="flex items-center gap-3">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <DocumentDuplicateIcon className="w-4 h-4 text-purple-600" />
          </span>
          <div className="mb-2"><strong>Duplicate:</strong> Creates a copy of the current panel with the same settings and data.</div>
        </div>
        {/* Exclude Null Values */}
        <div className="flex items-center gap-3">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <NoSymbolIcon className="w-4 h-4 text-blue-700" />
          </span>
          <div className="mb-2"><strong>Exclude Null Values:</strong> Toggles the exclusion/inclusion of rows with missing values in the selected column (<code style={{ fontSize: '0.675rem' }}>PARSED_COLLECTION_DATE_START</code> for Timeline panels).</div>
        </div>
      </div>
    </section>

    <h3 className="text-sm font-bold text-gray-800 mb-2 border-b-2 border-gray-100 pb-1">Panel Types</h3>

    {/* --- TABLE PANEL --- */}
    <section className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <h4 className="font-bold text-gray-800">Table Panels</h4>
      </div>
      <p className="mb-2 text-gray-600">Main panel for visualizing tabular data, serving as a control center to open different specialized panels via the header buttons:</p>
            <div className="grid grid-cols-1 gap-3 border-b-2 border-gray-100">
        {/* Search */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <MagnifyingGlassIcon className="w-4 h-4 text-cyan-700" />
          </span>
          <div className="mb-2"><strong>Search:</strong> Toggles a keyword search bar to filter rows within the table. Press enter to run the search, press Esc to close the search bar.</div>
        </div>

          {/* Timeline */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <ArrowTrendingUpIcon className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>Timeline:</strong> Opens a time-series plot to visualise the cumulative distribution of samples over time (using the <code style={{ fontSize: '0.675rem' }}>PARSED_COLLECTION_DATE_START</code> column).</div>
        </div>

        {/* Map */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <MapIcon className="w-4 h-4 text-blue-700" />
          </span>
          <div className="mb-2"><strong>Map:</strong> Visualise the samples in the table on a map.</div>
        </div>


        {/* Stats */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <ChartBarIcon className="w-4 h-4 text-purple-700" />
          </span>
          <div className="mb-2"><strong>Charts:</strong> Opens a panel allowing to visualise the distribution of values in a selected column either as a bar chart or a pie/donut chart.</div>
        </div>

        {/* Taxonomy */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <TreeGlyph className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>LifeMap:</strong> Visualise the samples' hosts in the entire tree of life.</div>
        </div>

        {/* Histograms */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <ChartBarSquareIcon className="w-4 h-4 text-orange-700" />
          </span>
          <div className="mb-2"> <strong>Histogram:</strong> Opens a panel allowing to visualise the distribution of values in a selected numeric column as an histogram.</div>
        </div>


        {/* Scatterplots */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <ScatterGlyph className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>Scatterplot:</strong> Opens a panel allowing to visualise the distribution of values in two selected numeric columns as a scatterplot. Color
           the points via the values in a third selected column.</div>
        </div>
        

      </div>
      <ul className="mt-2 space-y-2 list-none">
        <li><strong>Targeted Search:</strong> Click a column header to select it (blue highlight) or deselect it. Searches will then only look for keywords within the selected columns.</li>
        <li><strong>Highlighting:</strong> Search matches are highlighted in yellow within the cells.</li>
        <li><strong>Column Resizing:</strong> Drag the right edge of any header to adjust its width.</li>
        {/* <li><strong>Geo-Detection:</strong> Automatically detects <code>latitude</code>, <code>longitude</code>, and <code>geometry</code> strings for mapping.</li> */}
      </ul>
    </section>

    {/* --- MAP PANEL --- */}
    <section className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      
      <div className="flex items-center gap-2 mb-2">

        <h4 className="font-bold text-gray-800">Map Panels</h4>
      </div>
      {/* Spatial Filter */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <ViewfinderCircleIcon className="w-4 h-4 text-blue-700" />
          </span>
          <div className="mb-2"><strong>Broadcast Geo:</strong> When active, the map's current view boundaries act as a spatial filter for all other linked panels, these will only display the samples whose coordinates fall within the view boundaries.
           Moreover, when active the legend will only display the categories present in view and only the visible points will be considered for gradient coloring.</div>
        </div>

      {/* Map */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <MapIcon className="w-4 h-4 text-blue-700" />
          </span> 
          <div className="mb-2"><strong>Map type:</strong> Switch between a Mercator projection, a Robinson projection or a Globe view for the map. <div className='text-gray-500 text-xs'>(Note: geographic broadcasting is currently only available when the Mercator projection is selected)</div></div>
        </div>
      {/* Gradient toggle */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
           <div className="m-1 min-w-[12px] h-4 w-4 border border-gray-800 transition colors bg-gradient-to-r from-yellow-400 to-red-500 rounded-full" />
          <div className="mb-2"><strong>Gradient toggle: </strong>In the bottom right corner of the map, switch between Categorical (unique colors for value in the selected column) and a Gradient coloring scheme. </div>
        </div>
      {/* Point Settings */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-8 h-8 rounded-full border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <CogGlyph className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>Point Settings:</strong> Access the menu   in the upper left corner of the map to adjust the minimum/maximum point size and line thickness.</div>
        </div>

      <ul className="mt-2 space-y-2 list-none">
        <li><strong>Column selection:</strong> Select the column to be used to color the samples on the map.</li>
        <li><strong>Point Expansion:</strong> Multiple samples may have the same location, the radius of these points is proportional to their sample count. Click such a point to "explode" it into a radial cluster of individual samples for inspection, click again on the center to collapse the cluster.</li>
      </ul>
    </section>

    {/* --- TIMELINE PANEL --- */}
    <section className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <h4 className="font-bold text-gray-800">Timeline panels</h4>
      </div>
      <p className="mb-2 text-gray-600">Tracks cumulative sample collection over time. </p>
      <div className="flex items-center gap-3 border-b-2 border-gray-100">
           <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <LogGlyph className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>Log scale toggle: </strong>Toggle to enable/disable logarithmic scaling along the y axis.</div>
        </div>
      <ul className="space-y-1.5 list-none">
        <li><strong>Range Selection:</strong> Drag the vertical handles to filter all the linked panels using the selected time window, hover over the handles to see exact ISO dates.</li>
        <li><strong>Precise Selection:</strong> Use the date-picker inputs in the header for precision filtering (DD/MM/YYYY).</li>
      </ul>
    </section>

    {/* --- STATS PANEL --- */}
    <section className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <h4 className="font-bold text-gray-800">Chart panels</h4>
      </div>
      <p className="mb-2 text-gray-600"> Visualise the distribution of values in a selected column. The colors are the ones used for the same categories on the map(s).</p>
      {/* Pie/Bar Toggle */}
      <div className="flex items-center gap-3 border-b-2 border-gray-100">
        <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
          <ChartPieIcon className="w-4 h-4 text-green-700" />
        </span>/        <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
          <Bars3BottomLeftIcon className="w-3 h-3 text-green-700"/>
        </span>
        <div className="mb-2"><strong>Chart Type:</strong> Switches view between Pie/Donut and Bar charts.</div>
      </div>
      {/* Pie Settings */}
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
          <span className="w-8 h-8 rounded-full border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <CogGlyph className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>Point Settings:</strong> Access the menu in the lower left corner to adjust Start Rotation, Sweep Angle, and Inner/Outer Radius (to create donut charts).</div>
        </div>
      <ul className="mt-2 space-y-2 list-none">
        <li><strong>Smart Aggregation:</strong> Displays the top 15 categories; everything else is automatically grouped into "Other".</li>
        <li><strong>Filtering capabilities:</strong> Click on any category to filter all linked panels: They will display only the samples matching the selected category in the chosen column, click again to remove the filter.</li>
      </ul>
    </section>

    {/* --- LIFEMAP PANEL --- */}
    <section className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <h4 className="font-bold text-gray-800">LifeMap Panels</h4>
      </div>
      <p className="mb-2 text-gray-600">Provide taxonomic context exploring host diversity in the entire tree of life.</p>
      <ul className="mt-2 space-y-2 list-none">
        <li><strong>Auto-Mapping:</strong> Automatically scans for <code>tax_id</code> or <code>taxon_id</code> columns.</li>
        <li><strong>NCBI Integration:</strong> Projects the current samples as red dots onto the global taxonomic hierarchy using <a href="https://lifemap.cnrs.fr/" className='text-blue-800'>LifeMap</a> . Zoom in to see lineages from Phylum down to Species.</li>
        <li><strong>Auto-Zoom:</strong> Automatically adjusts the zoom level to fit the hosts for the currently displayed data.</li>
        <li><strong>Highlighting:</strong> Highlights the host corresponding to the currently selected sample.</li>
      </ul>
    </section>

    {/* --- NUMERIC DISTRIBUTION PANEL --- */}
    <section className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <h4 className="font-bold text-gray-800">Numeric distribution Panels</h4>
      </div>
      <p className="mb-2 text-gray-600">Plot the distribution of values in a numeric column as an histogram.</p>
        <div className="flex items-center gap-3 border-b-2 border-gray-100">
           <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <LogGlyph className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>Log scale toggle: </strong>Toggle to enable/disable logarithmic scaling along the y axis.</div>
        </div>
      <ul className="space-y-1.5 list-none">
        <li><strong>Range Selection:</strong> Drag the vertical handles to filter all the linked panels using the selected window of values.</li>
        <li><strong>Precise Selection:</strong> Use the picker inputs in the header for precision filtering.</li>
      </ul>
    </section>

    {/* --- SCATTERPLOT PANEL --- */}
    <section className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <h4 className="font-bold text-gray-800">Scatterplot Panels</h4>
      </div>
      <p className="mb-2 text-gray-600">Plot the distribution of values in two numeric columns of choice, with the currently active filters, as a scatterplot.
        Choose a column for the values along the x axis, one for those along the y axis and a third to color the points.
      </p>
      <div className="flex items-center gap-3 border-b-2 border-gray-100">
           <div className="m-1 min-w-[12px] h-4 w-4 border border-gray-800 transition colors bg-gradient-to-r from-yellow-400 to-red-500 rounded-full" />
          <div className="mb-2"><strong>Gradient toggle: </strong>Switch between categorical and
        gradient coloring when a numeric column is selected to color the points.</div>
        </div>
            <div className="flex items-center gap-3">
           <span className="w-6 h-6 rounded-md border border-gray-300 bg-white flex items-center justify-center shrink-0">
            <LogGlyph className="w-4 h-4 text-green-700" />
          </span>
          <div className="mb-2"><strong>Log scale toggle: </strong>Toggle to enable/disable logarithmic scaling along the y axis.</div>
        </div>
    </section>


  </div>
  
)}
      </div>
    </div>
  );
}